import {
  VolleyballAttributeId,
  VolleyballEventStatusId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  getBlockedPitchIncidentsMap,
  PitchIncidents,
  PitchIncidentsConfig,
} from '../../configuration'
import { pitchBlockedEventStatus } from './pitchBlockedEventStatus'

const pitchIncidents: PitchIncidents<
  VolleyballIncidentId,
  VolleyballAttributeId
> = {
  gridClass: 'grid-cols-3',
  buttonHeightClass: 'min-h-11 max-h-15',
  incidentButtonData: [
    [
      {
        incidentId: VolleyballIncidentId.ServiceAce,
        breakLine: true,
      },
      {
        incidentId: VolleyballIncidentId.ServiceError,
        breakLine: true,
      },
      {
        incidentId: VolleyballIncidentId.Challenge,
      },
    ],
    [
      {
        incidentId: VolleyballIncidentId.AttackPoint,
        breakLine: true,
      },
      {
        incidentId: VolleyballIncidentId.AttackError,
        breakLine: true,
      },
      {
        incidentId: VolleyballIncidentId.SetBall,
        breakLine: true,
      },
    ],
    [
      {
        incidentId: VolleyballIncidentId.BlockPoint,
        breakLine: true,
      },
      {
        incidentId: VolleyballIncidentId.TechnicalErrors,
        name: 'Tech. error',
        breakLine: true,
      },
      {
        incidentId: VolleyballIncidentId.MatchBall,
        breakLine: true,
      },
    ],
    [
      {
        incidentId: VolleyballIncidentId.Point,
      },
      {
        incidentId: VolleyballIncidentId.Cards,
        name: 'Card',
      },
      {
        incidentId: VolleyballIncidentId.SetWon,
        confirmingStrategy: {
          getConfirmationDescription: (_, currentParticipant) =>
            `Do you want to send Set won incident for ${currentParticipant?.name}?`,
        },
        blockingStrategy: {
          unblockInstructions:
            'You can’t send "Set won" with the current set result',
          isBlocked: ({
            homeResult,
            homeParticipantId,
            awayResult,
            awayParticipantId,
            currentParticipant,
          }) => {
            if (homeResult === undefined || awayResult === undefined) {
              throw new Error('result is not defined')
            }

            if (homeResult === awayResult) {
              return true
            }

            return (
              (homeResult > awayResult &&
                awayParticipantId === currentParticipant?.id) ||
              (awayResult > homeResult &&
                homeParticipantId === currentParticipant?.id)
            )
          },
        },
      },
    ],
  ],
}

const eventStatusToBlockedPitchIncidentsTextMap = new Map<
  VolleyballEventStatusId,
  string
>([
  [VolleyballEventStatusId.NotStarted, 'start 1st set'],
  [VolleyballEventStatusId.StartDelayed, 'start 1st set'],
  [VolleyballEventStatusId.BreakAfterFirstSet, 'start 2nd set'],
  [VolleyballEventStatusId.BreakAfterSecondSet, 'start 3rd set'],
  [VolleyballEventStatusId.BreakAfterThirdSet, 'start 4th set'],
  [VolleyballEventStatusId.BreakAfterFourthSet, 'start 5th set'],
])

const blockedPitchIncidentsMap = getBlockedPitchIncidentsMap(
  pitchBlockedEventStatus,
  pitchIncidents.incidentButtonData,
)

export const pitchIncidentsConfig: PitchIncidentsConfig<
  VolleyballEventStatusId,
  VolleyballIncidentId,
  VolleyballAttributeId
> = {
  pitchIncidents,
  blockedPitchIncidentsMap,
  eventStatusToBlockedPitchIncidentsTextMap,
}
